import React, { useEffect, useState } from 'react';
import {
    Button, Col, Container, Form, Modal, Row, Table, Card, InputGroup, FormControl, Spinner, Pagination, Alert
} from 'react-bootstrap';
import { FaEdit, FaEye, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import ConfirmModal from '.././ConfirmModal';
import 'react-toastify/dist/ReactToastify.css';

import PutyovkaService from '../../services/PutyovkaService';
import TransportService from '../../services/TransportService';
import FaylService from "../../services/FaylService";
import PutyovkaFormModal from ".././PutyovkaFormModal";
import {useParams} from "react-router-dom";
import {FaEarthAsia} from "react-icons/fa6";

const ShowPutyovka = ({ transportId }) => {
    // const {transportId} = useParams();
    const [list, setList] = useState([]);
    const [transportList, setTransportList] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [expiryFilter, setExpiryFilter] = useState('0');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        transport_id: '',
        raqam: '',
        narx: '',
        dan: '',
        gacha: '',
        shafyors: [],
        putyofka_priseps: [],
        putyofka_yonalishs: []
    });

    const perPageOptions = [5, 10, 20, 50, 100];

    useEffect(() => {
        loadTransports();
    }, []);

    useEffect(() => {
        loadData();
    }, [currentPage, perPage, searchTerm, sortOrder, expiryFilter]);

    const loadTransports = async () => {
        const res = await TransportService.getTransportList();
        setTransportList(res.data);
    };

    const loadData = async () => {
        console.log('transportId', transportId)
        setLoading(true);
        const res = await PutyovkaService.getPutyovkaList(currentPage, perPage, searchTerm, sortOrder, expiryFilter, transportId, 0);
        setList(res.data.data);
        setTotalItems(res.data.total);
        setLoading(false);
    };

    const getDayDiff = (gacha) => {
        const now = new Date();
        return Math.ceil((new Date(gacha) - now) / (1000 * 60 * 60 * 24));
    };

    const getColorClass = (days) => {
        if (days < 0) return 'text-danger fw-bold';
        if (days < 7) return 'text-warning fw-bold';
        return 'text-success fw-bold';
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const isEdit = !!formData.id;
        if (!formData.transport_id || !formData.raqam || !formData.dan || !formData.gacha || !formData.narx) {
            toast.error("Barcha asosiy maydonlarni to'ldiring!", { position: "bottom-right", autoClose: 3000 });
            return;
        }
        try {
            isEdit
                ? await PutyovkaService.updatePutyovka(formData, formData.id)
                : await PutyovkaService.addPutyovka(formData);
            toast.success(`Putyovka ${isEdit ? "yangilandi" : "qo‘shildi"}`, { position: "bottom-right", autoClose: 3000 });
            setShowModal(false);
            loadData();
        } catch {
            toast.error("Xatolik yuz berdi!");
        }
    };

    const handleEditClick = (item) => {
        setSelectedItem(item);
        setFormData({
            ...item,
            transportNumber: item.transport?.davlat_raqam || '',
            shafyors: item.shafyors || [],
            putyofka_priseps: item.putyofka_priseps || [],
            putyofka_yonalishs: item.putyofka_yonalishs || []
        });
        setShowModal(true);
    };

    const handleDeleteClick = (item) => {
        setItemToDelete(item);
        setShowConfirmModal(true);
    };

    const confirmDelete = async () => {
        try {
            await PutyovkaService.deletePutyovka(itemToDelete.id);
            toast.success("Putyovka o‘chirildi", { position: "bottom-right", autoClose: 3000 });
            loadData();
        } catch {
            toast.error("O‘chirishda xatolik yuz berdi");
        } finally {
            setShowConfirmModal(false);
            setItemToDelete(null);
        }
    };

    const handleGetFile = async (item) => {
        if (!item.fayl || item.fayl === 'no_file' || item.fayl === 'undefined') {
            toast.error('Fayl mavjud emas');
            return;
        }
        const path = await FaylService.getFaylPath(item.fayl);
        window.open(path, '_blank');
    };

    const handlePerPageChange = (e) => {
        setPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to first page
    };

    const handlePdfGenerate = async (item, global) => {
        if (!item?.id) {
            toast.error('Fayl olishda xatolik');
            return;
        }

        const token = localStorage.getItem('token');
        const url = `https://logistika.smart-trade.uz/api/pdf_generator/putyofka/${item.id}?global=${global}&token=${token}`;

        window.open(url, '_blank');
    };
    return (
        <Container fluid className="py-4">
            {/*<ToastContainer />*/}
            <Card className="mb-4">
                {/*<Card.Header className="d-flex justify-content-between align-items-center">*/}
                {/*    <h5 className="mb-0">Putyovkalar ro‘yxati</h5>*/}
                {/*    /!*<Button variant="primary" onClick={() => {*!/*/}
                {/*    /!*    setFormData({*!/*/}
                {/*    /!*        transport_id: '',*!/*/}
                {/*    /!*        raqam: '',*!/*/}
                {/*    /!*        narx: '',*!/*/}
                {/*    /!*        dan: '',*!/*/}
                {/*    /!*        gacha: '',*!/*/}
                {/*    /!*        shafyors: [],*!/*/}
                {/*    /!*        putyofka_priseps: [],*!/*/}
                {/*    /!*        putyofka_yonalishs: []*!/*/}
                {/*    /!*    });*!/*/}
                {/*    /!*    setShowModal(true);*!/*/}
                {/*    /!*}}>*!/*/}
                {/*    /!*    <FaPlus className="me-2" /> Qo‘shish*!/*/}
                {/*    /!*</Button>*!/*/}
                {/*</Card.Header>*/}
                <Card.Body style={{backgroundColor: 'white'}}>
                    <Form className="mb-4">
                        <Row>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tartiblash</Form.Label>
                                    <Form.Select value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
                                        <option value="asc">Tugash muddati (asc)</option>
                                        <option value="desc">Tugash muddati (desc)</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Muddati</Form.Label>
                                    <Form.Select value={expiryFilter} onChange={e => setExpiryFilter(e.target.value)}>
                                        <option value="0">Hammasi</option>
                                        <option value="-1">Muddati o'tganlar</option>
                                        <option value="7">Kam qolganlar (&lt;7 kun)</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Qidiruv</Form.Label>
                                    <InputGroup>
                                        <FormControl
                                            placeholder="Putyovka raqam, transport raqam..."
                                            value={searchTerm}
                                            onChange={e => setSearchTerm(e.target.value)}
                                        />
                                        <Button variant="outline-secondary"><FaSearch /></Button>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead
                                // className="table-dark"
                                // className="bg-primary text-white"
                            >
                            <tr>
                                <th>#</th>
                                <th>Putyovka raqam</th>
                                <th>Transport raqam</th>
                                <th>Muddati</th>
                                <th>Kun farqi</th>
                                <th>Narx</th>
                                <th>Priseplar</th>
                                <th>Haydovchilar</th>
                                <th>Yo‘nalishlar</th>
                                <th>Amallar</th>
                            </tr>
                            </thead>
                            <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" className="text-center">
                                        <Spinner animation="border" />
                                    </td>
                                </tr>
                            ) : list.length === 0 ? (
                                <tr>
                                    <td colSpan="10" className="text-center">Ma'lumot topilmadi</td>
                                </tr>
                            ) : (
                                list.map((item, i) => {
                                    const days = getDayDiff(item.gacha);
                                    const prisepslar = item.putyofka_priseps?.map(p => p.transport.davlat_raqam).join(', ');
                                    const haydovchilar = item.shafyors?.map(s => s.shafyor.name).join(', ');
                                    const yonalishlar = item.putyofka_yonalishs?.map(y => `${y.from_davlat} → ${y.to_davlat}`).join(', ');

                                    return (
                                        <tr key={item.id}>
                                            <td>{(currentPage - 1) * perPage + i + 1}</td>
                                            <td>{item.raqam}</td>
                                            <td>{item.transport?.davlat_raqam}</td>
                                            <td>{item.gacha}</td>
                                            <td className={getColorClass(days)}>{days}</td>
                                            <td>{item.narx}</td>
                                            <td>{prisepslar}</td>
                                            <td>{haydovchilar}</td>
                                            <td>{yonalishlar}</td>
                                            <td>
                                                <div className="d-flex">
                                                    {/*<Button variant="link" size="sm" className="text-warning p-0 me-2" onClick={() => handleEditClick(item)}><FaEdit /></Button>*/}
                                                    {/*<Button variant="link" size="sm" className="text-danger p-0 me-2" onClick={() => handleDeleteClick(item)}><FaTrash /></Button>*/}
                                                    <Button variant="link" size="sm" className="text-primary p-0 me-2"
                                                            onClick={() => handlePdfGenerate(item, 0)}><FaEye/></Button>
                                                    <Button variant="link" size="sm" className="text-primary p-0"
                                                            onClick={() => handlePdfGenerate(item, 1)}><FaEarthAsia/></Button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="d-flex align-items-center">
                            <span className="me-2">Har sahifada:</span>
                            <Form.Select
                                style={{ width: '80px' }}
                                value={perPage}
                                onChange={handlePerPageChange}
                                disabled={loading}
                            >
                                {perPageOptions.map(option => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </Form.Select>
                            <span className="ms-2">{loading ? 'Yuklanmoqda...' : `Jami: ${totalItems} ta`}</span>
                        </div>
                        {Math.ceil(totalItems / perPage) > 1 && (
                            <Pagination className="mb-0">
                                <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                                {[...Array(Math.ceil(totalItems / perPage))].map((_, i) => (
                                    <Pagination.Item
                                        key={i}
                                        active={i + 1 === currentPage}
                                        onClick={() => setCurrentPage(i + 1)}
                                    >
                                        {i + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Last onClick={() => setCurrentPage(Math.ceil(totalItems / perPage))} disabled={currentPage === Math.ceil(totalItems / perPage)} />
                            </Pagination>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <ConfirmModal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                onConfirm={confirmDelete}
                title="Putyovkani o‘chirish"
                message={`Rostan ham "${itemToDelete?.raqam}" raqamli putyovkani o‘chirmoqchimisiz?`}
            />

            <PutyovkaFormModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onSave={handleSave}
                formData={formData}
                setFormData={setFormData}
            />
        </Container>
    );
};

export default ShowPutyovka;
